import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * tip endpoints
 */
export const fetchTips = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/tips', q, page, perPage, sortOpts, extraParams);

export const fetchTip = (tipId) => request.fetchDetail(`/tips/${tipId}`);

export const createTip = (payload) =>
  request.postJSON(
    '/tips',
    excludeObjNullValue({
      title: payload.title,
      body: payload.body,
      type: payload.type,
      level: payload.level,
    }),
  );

export const updateTip = (payload) =>
  request.putJSON(
    `/tips/${payload.tipId}`,
    excludeObjNullValue({
      title: payload.title,
      body: payload.body,
      type: payload.type,
      level: payload.level,
    }),
  );

export const deleteTip = (tipId) => request.deleteReq(`/tips/${tipId}`);
